
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import Vue from 'vue';
  import { Line as LineChart} from 'vue-chartjs'
  import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js/auto'

  import Chart from 'chart.js/auto';
  import { IReferenceDashboardResource } from '@/types/resource.types';
  
  @Component({
      name: 'ReferenceDashboardGraph',
      components: {
        LineChart
      }
  })
  
  
  export default class ReferenceDashboardGraph extends Vue {

    /* Props
    ============================================*/
      @Prop({type: Object, required: true})
      readonly referenceDashboard: IReferenceDashboardResource;
      
    $refs!: {
        line: HTMLCanvasElement
    }
    
    randomIterator: number = 0;
    chart: Chart | null;
    /* Data
    ============================================*/
  myStyles: object = {
        height: '100%',
        width: '100%',
        position: 'relative'
      };
  
    /* Computed
    ============================================*/
    get menuCollapsed(){
      return this.$store?.state?.menuIsCollapsed;
    }
    chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          x: {
                beginAtZero: true
            },
            y: {
                beginAtZero: true
            }
        };
    }
    color(format : string){
        switch(format){
            case "Total":
                return "#001b78";
            case "jpg":
                return "#00b159";
            case "3gp":
                return "#d11141";
            case "asf":
                return "#00aedb";
            case "avi":
                return "#f37735";
            case "m4a":
                return "#ffc425";
            case "m4v":
                return "#9467bd";
            case "mov":
                return "#1f77b4";
            case "mp4":
                return "#7f7f7f";
            case "mpg":
                return "#2ca02c";
            case "heic":
                return "#ff69b4";
            case "png":
                return "#17becf";
        }

        return this.getRandomColor();
    }

    getRandomColor(){
        let colors = [
            "#e377c2",
            "#7f7f7f",
            "#bcbd22",
            "#17becf",
            "#ff7f0e",
            "#6a3d9a",
            "#b15928",
            "#393b79",
            "#5254a3",
            "#637939",
        ];
        if(this.randomIterator > colors.length) return "#ffffff";
        return colors[this.randomIterator];
    }
    get chartData(){
        var data = [];
        var labels = [];

        if(this.referenceDashboard){
            for(let i = 0; i < this.referenceDashboard.datasets.length; i++){
                let thisDataset = this.referenceDashboard.datasets[i];
                data.push({
                        data: thisDataset.data,
                        label: thisDataset.label,
                        borderColor: this.color(thisDataset.label)
                    });
                labels.push(thisDataset.label);
            }
            return {
                labels: this.referenceDashboard.monthLabels,
                datasets: data
                }
        }
        return {labels:[], datasets:[]};
    }
    
    createChart() {
      const elem = this.$refs?.line?.getContext("2d");
      if(elem){
        this.chart = new Chart(elem, {
            type: 'line',
            data: this.chartData,
            options: this.chartOptions()
        });
      }
    }
    @Watch('menuCollapsed')
    onMenuIsCollapsed() {
    }
  }
  
  
  